// extracted by mini-css-extract-plugin
export default {"container":"styles_container__K6Z-e","textWrapper":"styles_textWrapper__T3+sJ","title":"styles_title__udZlg","description":"styles_description__QHr3Y"};